module.exports = __webpack_public_path__ + "img/stretcher-icon.df29d922.png";